import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=8b53305c&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b53305c",
  null
  
)

export default component.exports